<script>
	import { getContext } from "svelte";
  import { LayerCake, Svg, Html, groupLonger, flatten } from "layercake";
  import { px } from '../../utils'

	const { rDomain, rRange, rScale, rGet } = getContext("LayerCake");

  const PADDING = 10;
  // hackyhacky...
  const ALPHA_CONSTANT = '80';

  export let addMargin;
//  export let stroke;
  export let fill;
  export let label = '';
  export let textColor = '#BDBDBD';


</script>

<div class="container" class:addMargin>
  <div
    class="circle"
    style:border-color={fill}
    style:background-color={fill + ALPHA_CONSTANT}
  />
  <div class="label" style:color={fill}>{label}</div>
</div>
	

<style lang="scss">
	.container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    &.addMargin {
      margin-top: -12px;

      @media (max-width: 420px) {
        margin-top: -18px;
      }
    }
  }

  .circle {
    content: "";
    border-radius: 20px;
    border: 1px solid;
    height: 14px;
    width: 14px;
  }

  .label {
    font-size: 16px;
    margin-left: 5px;

    @media (max-width: $breakpoint-mobile) {
			font-size: 14px;
      line-height: 16px;
      max-height: 36px;
		}

  }
</style>
